import * as yup from "yup";

const webServiceSchema = yup.object({
  name: yup.string().required("نام الزامی").min(2, "حداقل 2 کاراکتر"),

  family: yup
    .string()
    .required("نام خانوادگی الزامی")
    .min(2, "حداقل 2 کاراکتر"),
  mobile: yup
    .string()
    .required("شماره همراه الزامی")
    .length(11, "شماره همراه باید 11 رقم باشد")
    .matches(/^09\d{9}$/, "شماره همراه باید با 09 شروع شود"),

  phone: yup
    .string()
    .test("isValidPhone", "شماره تلفن باید 11 رقم باشد", value => {
      if (value && value.length !== 11) {
        return false;
      }

      if (value && value[0] !== "0") {
        return false;
      }

      return true;
    }),

  webSiteAddress: yup
    .string()
    .required("آدرس وب سایت الزامی")
    .min(3, "حداقل 3 کاراکتر"),
  businessType: yup
    .string()
    .required("نوع کسب و کار الزامی")
    .min(3, "حداقل 3 کاراکتر"),
});

export default webServiceSchema;
